import { NavLink, useHistory } from 'react-router-dom';
import {
  Activity,
  BaggageClaim,
  BookmarkPlus,
  BookOpenText,
  BookUser,
  CalendarClock,
  CalendarDays,
  ChartLine,
  ChartNoAxesCombined,
  Clock,
  ClockArrowDown,
  Cog,
  DollarSign,
  FileClock,
  Building2,
  FolderKanban,
  HandCoins,
  HeartHandshake,
  Key,
  LayoutDashboard,
  LayoutPanelTop,
  Lightbulb,
  ListCheck,
  ListChevronsDownUp,
  Lock,
  Mail,
  Map,
  MonitorStop,
  Phone,
  Receipt,
  ReceiptText,
  RotateCcwKey,
  ScrollText,
  ShieldCheck,
  Store,
  TicketsPlane,
  TriangleAlert,
  User,
  UserLock,
  UserPlus,
  UserRoundCog,
  Users,
  Wallet,
  Warehouse,
  WifiSync,
  Wrench,
} from 'lucide-react';

import {
  clientDetails,
  CONFIG,
  PF_ADMIN,
  VIEW_DASHBOARD_PERFORMANCE_USERS,
} from '../../../../constants';
import { isRingCentralEnabled } from '../components/ringCentral/ringCentralConfig';
import permissions from '../../../../config/permissions';
import { REACT_APP_PF_ADMIN_ID } from '../../../../constants/envConstants';
import { CLIENT_ID } from '../../../../constants/client.constant';
export const tenantId = ['22PF89TG', '10PF26DC'];

export const legacyWidgetsDashboards = ['Legacy Widgets', 'Legacy Dashboards'];

export const menuItemsList = (
  setDailogVisible,
  clientId,
  permissionList,
  fixedMenuBar
) => {
  const history = useHistory();

  const menuJson = [
    {
      label: 'Help',
      icon: (
        <div className="root-icons">
          <HeartHandshake size="small" />
        </div>
      ),
      command: () => history.push('/getstarted'),

      permission: 'HELP',
      className: 'root-menu',
    },

    {
      label: 'Dashboard',
      icon: (
        <div className="root-icons">
          <LayoutDashboard size="small" />
        </div>
      ),
      permission: 'HOME_M',
      command: () => history.push('/dashboard'),

      className: fixedMenuBar ? 'py-0 root-menu' : 'root-menu',
    },
    {
      label: 'Project',
      icon: (
        <div className="root-icons">
          <FolderKanban size="small" />
        </div>
      ),
      permission: 'PROJECT_M',
      className: 'root-menu',
      items: [
        {
          command: () => history.push('/scheduler'),
          label: 'Scheduler',
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-sm bg-purple-50">
              <Clock className="text-purple-600" />
            </div>
          ),
          permission: 'SCHEDULER_M',
          className: 'menu-level-first',
        },
        {
          command: () => history.push('/calendar'),
          label: 'Calendar',
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-blue-50">
              <CalendarDays className="text-blue-600" />
            </div>
          ),
          permission: 'VIEW_CALENDAR',
          className: 'menu-level-first',
        },
        {
          command: () => history.push('/project/map'),
          label: 'Map',
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-green-50">
              <Map className="text-green-600" />
            </div>
          ),
          permission: 'MAP_VIEW',
          className: 'menu-level-first',
        },
        CONFIG.ENABLE_CUSTOMER_LIST === '1' && {
          label: <NavLink to={'/project/clients'}>Clients</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-orange-600">
              <Users className="text-orange-600" />
            </div>
          ),
          permission: 'CLIENTS_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/crm/add/customer'}>Add Client</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-primary-50">
              <UserPlus className="text-primary-600" />
            </div>
          ),
          permission: 'CLIENTS_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/project/items'}>Items</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
              <ListChevronsDownUp className="text-red-600" />
            </div>
          ),

          permission: 'ITEMS_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/project/add'}>Add Project</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-green-50">
              <BookmarkPlus className="text-green-600" />
            </div>
          ),
          permission: 'ADD_PROJECT',
          className: 'menu-level-first',
        },
        ...(parseInt(clientDetails?.vendor_purchase_order) === 1
          ? [
              {
                label: (
                  <NavLink to={'/project/vendormanagement'}>
                    Vendor Management
                  </NavLink>
                ),
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-orange-50">
                    <Store className="text-orange-600" />
                  </div>
                ),
                permission: 'VENDOR_MANAGEMENT_VIEW',
                className: 'menu-level-first',
              },
              {
                label: (
                  <NavLink to={'/project/general-orders'}>
                    General Purchase Orders
                  </NavLink>
                ),
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-bluegray-50">
                    <BaggageClaim className="text-bluegray-600" />
                  </div>
                ),
                permission: 'GENERAL_PURCHASE_ORDER_VIEW',
                className: 'menu-level-first',
              },
            ]
          : []),

        {
          label: (
            <NavLink
              to={'/pull-home-depot-project'}
              onClick={e => {
                e.preventDefault();
                setDailogVisible(true);
              }}
            >
              Pull Home Depot Project
            </NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
              <Wrench className="text-purple-600" />
            </div>
          ),
          permission: 'PULL_PROJECT_FROM_SOURCE',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/payment-request'}>Payment Request</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-primary-50">
              <DollarSign className="text-primary-600" />
            </div>
          ),
          permission: 'PAYMENT_REQUEST',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/data-import'}>Data Import</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
              <DollarSign className="text-purple-600" />
            </div>
          ),
          permission: 'UPLOAD_DATA_VIEW',
          className: 'menu-level-first',
        },
        ...((parseInt(clientDetails?.personalized_emails) === 1 ||
          parseInt(clientDetails?.crm_module) === 1) &&
        permissionList?.includes(permissions.template.view)
          ? [
              {
                label: 'Templates',
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-blue-50">
                    <LayoutPanelTop className="text-blue-600" />
                  </div>
                ),
                permission: 'TEMPLATE_VIEW',
                className: 'menu-level-first submenu-hover-bg-none',
                items: [
                  ...(parseInt(clientDetails?.personalized_emails) === 1
                    ? [
                        {
                          label: (
                            <NavLink
                              to={'/project/personalized-emails-template'}
                            >
                              Email
                            </NavLink>
                          ),
                          icon: (
                            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
                              <Mail className="text-red-600" />
                            </div>
                          ),
                          permission: 'EMAIL_TEMPLATE_VIEW',
                          className: 'menu-level-second',
                        },
                      ]
                    : []),
                  ...(parseInt(clientDetails?.crm_module) === 1
                    ? [
                        {
                          label: (
                            <NavLink to={'/project/Quote-template'}>
                              Quote
                            </NavLink>
                          ),
                          icon: (
                            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
                              <ReceiptText className="text-purple-600" />
                            </div>
                          ),
                          permission: 'QUOTE_TEMPLATE_VIEW',
                          className: 'menu-level-second',
                        },
                      ]
                    : []),
                ],
              },
            ]
          : []),
        {
          key: 'chargeback',
          label: (
            <NavLink to={'/project/chargeback/add'}>Add Chargeback</NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-orange-50">
              <Wallet className="text-orange-600" />
            </div>
          ),
          permission: 'ADD_APPROVE_CHARGEBACK',
          className: 'menu-level-first',
        },
      ],
    },
    {
      label: 'Admin',
      icon: (
        <div className="root-icons">
          <ShieldCheck size="small" />
        </div>
      ),
      permission: 'ADMIN_M',
      className: 'root-menu',
      items: [
        {
          key: 'call_history',
          label: <NavLink to={'/call-history'}>Call History</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-blue-50">
              <Phone className="text-blue-600" />
            </div>
          ),
          permission: 'HOME_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/warehouse'}>Warehouse</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
              <Warehouse className="text-purple-600" />
            </div>
          ),
          permission: 'LABOR_PROFILES_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/laborprofiles'}>Labor Profiles</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-yellow-50">
              <BookUser className="text-yellow-600" />
            </div>
          ),
          permission: 'LABOR_PROFILES_M',
          className: 'menu-level-first',
        },
        {
          label: (
            <NavLink to={'/admin/usermanagement'}>User Management</NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-cyan-50">
              <UserRoundCog className="text-cyan-600" />
            </div>
          ),
          permission: 'USER_MGMT_M',
          className: 'menu-level-first',
        },
        {
          label: (
            <NavLink to={'/admin/company-management'}>
              Company Management
            </NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-teal-50">
              <Building2 className="text-teal-600" />
            </div>
          ),
          permission: 'COMPANY_MANAGEMENT_VIEW',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/stores'}>Stores</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-green-50">
              <Store className="text-green-600" />
            </div>
          ),
          permission: 'STORE_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/dashboards'}>Dashboards</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
              <MonitorStop className="text-red-600" />
            </div>
          ),
          permission: 'DASHBOARD_MGMT_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/widgets'}>Widgets</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-indigo-50">
              <ChartLine className="text-indigo-600" />
            </div>
          ),
          permission: 'DASHBOARD_WIDGET_TEMPLATE',
          className: 'menu-level-first',
        },
        {
          label: (
            <NavLink to={'/admin/documentcenter'}>Document Center</NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-bluegray-50">
              <BookOpenText className="text-bluegray-600" />
            </div>
          ),
          permission: 'DOC_CENTER_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/ruleenginelogs'}>Event Logs</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
              <ClockArrowDown />
            </div>
          ),
          permission: 'RULE_ENGINE_LOGS_VIEW',
          className: 'menu-level-first',
        },
        {
          key: 'tenant_billing',
          label: <NavLink to={'/admin/tenant-billing'}>Tenant Billing</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-orange-50">
              <Receipt className="text-bluegray-600" />
            </div>
          ),
          permission: 'ADMIN_M',
          className: 'menu-level-first',
        },
        {
          label: <NavLink to={'/admin/configuration'}>Configuration</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
              <Cog className="text-red-600" />
            </div>
          ),
          permission: 'CONFIGURATION_M',
          className: 'menu-level-first',
        },
        {
          key: 'sso_configuration',
          label: (
            <NavLink to={'/admin/sso-configuration'}>SSO Configuration</NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
              <Key className="text-purple-600" />
            </div>
          ),
          permission: 'CONFIGURATION_M',
          className: 'menu-level-first',
        },
        {
          key: 'bulletin',
          label: <NavLink to={'/admin/bulletin'}>Bulletin</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-primary-50">
              <TriangleAlert className="text-primary-600" />
            </div>
          ),
          permission: 'CONFIGURATION_M',
          className: 'menu-level-first',
        },
        {
          key: 'payroll',
          label: <NavLink to={'/admin/payroll'}>Payroll</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-green-50">
              <HandCoins className="text-green-600" />
            </div>
          ),
          permission: 'VIEW_PAYROLL',
          className: 'menu-level-first',
        },
        {
          key: 'checklist',
          label: <NavLink to={'/admin/checklist'}>Checklist</NavLink>,
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-yellow-50">
              <ListCheck className="text-yellow-600" />
            </div>
          ),
          permission: 'QUESTIONNAIRE_VIEW',
          className: 'menu-level-first',
        },
        ...(parseInt(clientDetails?.user_activity_log) === 1
          ? [
              {
                key: 'user_activity',
                label: (
                  <NavLink to={'/admin/user-activity'}>User Activity</NavLink>
                ),
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-indigo-50">
                    <Activity className="text-indigo-600" />
                  </div>
                ),
                permission: 'USER_ACTIVITY',
                className: 'menu-level-first',
              },
            ]
          : []),
        {
          key: 'exported_reports',
          label: (
            <NavLink to={'/admin/export/reports'}>Exported Reports</NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-bluegray-50">
              <TicketsPlane className="text-bluegray-600" />
            </div>
          ),
          permission: 'VIEW_PAYROLL',
          className: 'menu-level-first',
        },

        ...[
          clientId === PF_ADMIN &&
          VIEW_DASHBOARD_PERFORMANCE_USERS.includes(
            localStorage.getItem('user_id')
          )
            ? {
                label: (
                  <NavLink to={'/admin/dashboard-performance-analysis'}>
                    Dashboard Analysis
                  </NavLink>
                ),
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-cyan-50">
                    <ChartNoAxesCombined className="text-cyan-600" />
                  </div>
                ),
                permission: 'HOME_M',
                className: 'menu-level-first',
              }
            : {},
        ],
        ...(clientId === REACT_APP_PF_ADMIN_ID
          ? [
              {
                key: 'help_page_config',
                label: (
                  <NavLink to={'/admin/help-page-config'}>
                    Help Page Config
                  </NavLink>
                ),
                icon: (
                  <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-blue-60">
                    <HeartHandshake className="text-blue-600" />
                  </div>
                ),
                permission: 'ADMIN_M',
                className: 'menu-level-first',
              },
            ]
          : []),
      ],
    },
    ...[
      clientId === PF_ADMIN && {
        label: 'Logs',
        icon: (
          <div className="root-icons">
            <ScrollText />
          </div>
        ),
        permission: 'ADMIN_M',
        className: 'root-menu',
        items: [
          ...[
            clientId === PF_ADMIN
              ? {
                  key: 'login_logs',
                  label: <NavLink to={'/logs/login-logs'}>Login Logs</NavLink>,
                  icon: (
                    <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
                      <FileClock className="text-red-600" />
                    </div>
                  ),
                  permission: 'HOME_M',
                  className: 'menu-level-first',
                }
              : {},
          ],
          ...[
            clientId === PF_ADMIN
              ? {
                  key: 'reset_passowrd_logs',
                  label: (
                    <NavLink to={'/logs/reset-password-logs'}>
                      Reset Password Logs
                    </NavLink>
                  ),
                  icon: (
                    <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-purple-50">
                      <RotateCcwKey className="text-purple-600" />
                    </div>
                  ),
                  permission: 'HOME_M',
                  className: 'menu-level-first',
                }
              : {},
          ],
          ...[
            clientId === PF_ADMIN
              ? {
                  key: 'customer_login_logs',
                  label: (
                    <NavLink to={'/logs/customer-login-logs'}>
                      Customer Login Logs
                    </NavLink>
                  ),
                  icon: (
                    <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-primary-60">
                      <Key className="text-primary-600" />
                    </div>
                  ),
                  permission: 'HOME_M',
                  className: 'menu-level-first',
                }
              : {},
          ],
          ...[
            clientId === PF_ADMIN
              ? {
                  key: 'customer_register_logs',
                  label: (
                    <NavLink to={'/logs/customer-register-logs'}>
                      Customer Register Logs
                    </NavLink>
                  ),
                  icon: (
                    <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-red-50">
                      <UserLock className="text-red-600" />
                    </div>
                  ),
                  permission: 'HOME_M',
                  className: 'menu-level-first',
                }
              : {},
          ],
          ...[
            clientId === PF_ADMIN
              ? {
                  key: 'customer_reset_password_logs',
                  label: (
                    <NavLink to={'/logs/customer-reset-password-logs'}>
                      Customer Reset Password Logs
                    </NavLink>
                  ),
                  icon: (
                    <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-green-50">
                      <WifiSync className="text-green-600" />
                    </div>
                  ),
                  permission: 'HOME_M',
                  className: 'menu-level-first',
                }
              : {},
          ],
        ],
      },
    ],

    {
      label: 'Personnel',
      icon: (
        <div className="root-icons">
          <User size="small" />
        </div>
      ),
      permission: 'PERSONNEL_M',
      className: 'root-menu',
      items: [
        {
          label: (
            <NavLink to={'/personnel/availabilityupdates'}>
              Availability Updates
            </NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-blue-50">
              <CalendarClock className="text-blue-600" />
            </div>
          ),
          permission: 'AVAILABILITY_UPDATE_M',
          className: 'menu-level-first',
        },
        {
          label: (
            <NavLink to={'/admin/usermanagement/user-form/add'}>
              Add New User
            </NavLink>
          ),
          icon: (
            <div className="icons flex justify-content-center align-items-center w-2rem h-2rem border-round-xs bg-bluegray-50">
              <UserPlus className="text-bluegray-600" />
            </div>
          ),
          className: 'menu-level-first',
        },
      ],
    },
    ...(clientId === REACT_APP_PF_ADMIN_ID ||
    clientId === CLIENT_ID.PF_VALIDATION
      ? [
          {
            key: 'help_page_config',
            label: <NavLink to={'/get-started'}>Quick Start & Help</NavLink>,
            icon: (
              <div className="root-icons">
                <Lightbulb size="small" />
              </div>
            ),
            permission: 'HELP',
            className: 'root-menu',
          },
        ]
      : []),
    {
      label: (
        <span
          onClick={() =>
            window.open('https://projectsforce.com/privacy-policy', '_blank')
          }
        >
          Privacy Policy
        </span>
      ),
      icon: (
        <div className="root-icons">
          <Lock />
        </div>
      ),
      permission: 'PERSONNEL_M',
      className: 'root-menu',
    },
  ];

  const filteredMenuItems = menuJson?.filter(menu => {
    if (
      permissionList?.includes(menu?.permission) ||
      menu?.permission == 'HELP'
    ) {
      if (['Legacy Dashboard'].includes(menu.label)) {
        if (tenantId?.includes(clientId)) {
          return true;
        } else {
          return false;
        }
      }
      if (menu?.items) {
        menu.items = menu.items.filter(submenu => {
          if (submenu.key === 'bulletin') {
            return clientId == PF_ADMIN;
          }
          if (submenu.key === 'call_history') {
            return (
              isRingCentralEnabled() &&
              (clientId == PF_ADMIN ||
                permissionList.includes('HOME_M') ||
                permissionList.includes('CONFIGURATION_M'))
            );
          }
          if (Array?.isArray(submenu?.items) && submenu?.items?.length > 0) {
            submenu.items = submenu?.items?.filter(itemsPermission =>
              permissionList.includes(itemsPermission.permission)
            );
            return submenu.items;
          }
          if (submenu?.key === 'tenant_billing') {
            return clientId === PF_ADMIN ? true : false; // show only for PF client
          }
          if (legacyWidgetsDashboards?.includes(submenu.label)) {
            if (tenantId?.includes(clientId)) {
              return true;
            } else {
              return false;
            }
          }
          return permissionList.includes(submenu.permission);
        });
      }
      return menu;
    }
    return false;
  });

  return filteredMenuItems;
};

export const WINDON_RELOAD_MESSAGE =
  'A video/image upload is currently in progress. Navigating away may interrupt the upload and result in data loss.';

export const VIDEO_UPLOAD_STATUS = {
  IDEAL: 'idle',
};

export const PROJECT_KEYS = ['project_number', 'po_number'];

export const PROJECT_AND_ADDRESS_KEYS = [
  'project_number',
  'po_number',
  'address',
];

export const SUGGESTION_ENABLED_KEYS = ['phone', 'client', 'address'];

export const FORCE_SUGGESTION_KEYS = ['phone', 'client'];

export const URL_REG_EXP = /[?&]searchType=([^&]+)&searchValue=([^&]+)/;
export const NO_DATA_FOUND = 'No data found';
